import * as Actions from "../redux/searchSession";
import * as OmniDataAPI from "../../data/omniDataAPI";

import { call, put, select, takeLatest } from "redux-saga/effects";

export function* searchPatients({ payload }) {
  try {
    if (payload) {
      let theReturn = yield call(OmniDataAPI.searchPatients, payload);
      yield put(Actions.searchPatientsSuccess(theReturn));
    } else {
      // searching for null essentially clears this
      yield put(Actions.searchPatientsSuccess(null));
    }
  } catch (error) {
    yield put(Actions.searchSessionRequestFail(error));
  }
}

export function* searchPartners({ payload }) {
  try {
    if (payload) {
      let theReturn = yield call(OmniDataAPI.searchPartners, payload);
      yield put(Actions.searchPartnersSuccess(theReturn));
    } else {
      // searching for null essentially clears this
      yield put(Actions.searchPartnersSuccess(null));
    }
  } catch (error) {
    yield put(Actions.searchSessionRequestFail(error));
  }
}

export function* searchProviders({ payload }) {
  try {
    if (payload) {
      let theReturn = yield call(OmniDataAPI.searchProviders, payload);
      yield put(Actions.searchProvidersSuccess(theReturn));
    } else {
      // searching for null essentially clears this
      yield put(Actions.searchProvidersSuccess(null));
    }
  } catch (error) {
    yield put(Actions.searchSessionRequestFail(error));
  }
}

export function* searchInvites({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.inviteSearchPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort)
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
    }

    let inviteSearchPages = yield select(Actions.inviteSearchPagesSelector);
    if (!currentCacheInvalid && inviteSearchPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.searchInvitesSuccess({
          pages: inviteSearchPages,
          items: inviteSearchPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchInvites, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        inviteSearchPages = {};
      }
      inviteSearchPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.searchInvitesSuccess({
          pages: inviteSearchPages,
          items: inviteSearchPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.searchSessionRequestFail(error));
  }
}

//  saga
export default function* adminDataSaga() {
  yield takeLatest(Actions.searchPatientsRequest, searchPatients);
  yield takeLatest(Actions.searchPartnersRequest, searchPartners);
  yield takeLatest(Actions.searchProvidersRequest, searchProviders);
  yield takeLatest(Actions.searchInvitesRequest, searchInvites);
}
